import { useMemo } from 'react';
import axios from 'axios';
import { useEnvironment } from '../contexts/EnvironmentContext';
import { createHttpOptions } from '../utils/CreateHttpOptions';
import { addAuthenticationInterceptors } from '@publicisgroupe/p-os-authentication';

const useHttp = (
  moduleName?: string | undefined,
  ignoreModuleName?: boolean
) => {
  const env = useEnvironment();

  const http = useMemo(() => {
    if (!env.isLoaded) {
      return null;
    }
    const params = {
      environment: env.settings.environment,
      baseUrl: env.settings.apiBaseURL,
      apiKey: env.settings.ocpApimKey,
    };

    const httpOptions = createHttpOptions(
      params,
      ignoreModuleName ? undefined : moduleName || env.moduleName
    );

    const axiosInstance = axios.create(httpOptions);

    addAuthenticationInterceptors(axiosInstance);

    return axiosInstance;
  }, [
    env.isLoaded,
    env.settings.environment,
    env.settings.apiBaseURL,
    env.settings.ocpApimKey,
    env.moduleName,
    ignoreModuleName,
    moduleName,
  ]);

  return http;
};

export default useHttp;
